export default __webpack_public_path__ + "static/media/user.30a1a8d0.png";